import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchCategories } from "./dailySentenceService";
import "./DailySentenceListPage.css";

const DailySentenceListPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      console.log("[DailySentenceListPage] Loading categories, search:", search);
      setLoading(true);
      const res = await fetchCategories({ search: search || undefined });
      if (res.status === 200 && res.data?.status) {
        console.log("[DailySentenceListPage] Loaded", res.data.data?.length || 0, "categories");
        setCategories(res.data.data || []);
      } else {
        console.error("[DailySentenceListPage] Load failed:", res.status, res.message);
        setCategories([]);
      }
      setLoading(false);
    };
    load();
  }, [search]);

  return (
    <>
      <Navbar />
      <div className="ds-page">
        <h1 className="ds-title">💬 Daily Sentences</h1>
        <p className="ds-subtitle">Practice everyday English sentences for real-life conversations.</p>

        <div className="ds-filters">
          <input
            className="ds-search"
            type="text"
            placeholder="Search categories..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <p className="ds-loading">Loading...</p>
        ) : categories.length === 0 ? (
          <p className="ds-empty">No categories available yet.</p>
        ) : (
          <div className="ds-grid">
            {categories.map((c) => (
              <div key={c.id} className="ds-card" onClick={() => navigate(`/study/daily-sentences/category/${c.id}`)}>
                <span className="ds-card-icon">{c.icon || "📂"}</span>
                <h3 className="ds-card-title">{c.title}</h3>
                {c.description && <p className="ds-card-desc">{c.description}</p>}
                <span className="ds-card-count">{c.sentenceCount || 0} sentences</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default DailySentenceListPage;
